import {Component, Input, OnInit} from '@angular/core';
import {InstallationQuote} from '../../data/Installation-quote';
import {environment} from '../../../environments/environment';
import {QuotesService} from '../../data/quotes.service';
import {MiscSnackBarService} from '../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-installation-quote-body',
  templateUrl: './installation-quote-body.component.html',
  styleUrls: ['./installation-quote-body.component.scss']
})
export class InstallationQuoteBodyComponent implements OnInit {
  @Input()
  quoteCode: string;

  @Input()
  quote: InstallationQuote

  files: File[] = [];

  systemState = environment.systemState

  sendLoading = false;

  quoteSent = false;

  constructor(
    private router: Router,
    protected quotesService: QuotesService,
    protected miscSnackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit(): void {
    if (!this.quote) {
      const quoteCodes = this.router.url.split('/')
      this.quoteCode = quoteCodes[1];

      if (!this.quoteCode) return

      this.quotesService.getQuoteByCode(this.quoteCode).subscribe(quote => {
        this.quote = quote
        this.quote.code = this.quoteCode
      })
    }
  }

  sendQuote() {
    this.sendLoading = true;
    let service = this.quotesService.sendQuoteByCode(this.quoteCode, this.quote);

    if (!this.quoteCode) {
      service = this.quotesService.sendQuote(this.quote)
    }

    service.subscribe(res => {
      this.miscSnackBarService.openSuccessSnackBar('Quote Successfully Sent!')
      this.sendLoading = false;
      this.quoteSent = true;
    }, error => {
      this.sendLoading = false;
      this.miscSnackBarService.openErrorSnackBar(error.message)
    })

  }


  openSystem() {
    if (this.systemState === 'Seattle') {
      location.assign(environment.systemSeattleUrl)
    }
    if (this.systemState === 'California') {
      location.assign(environment.systemCaliforniaUrl)
    }
  }
}
